import React, { useEffect, useState } from 'react';
import { apiFetch, parseJsonSafe } from '../utils/api';

const EmailMarketingJobsModal = ({ campaignId, onClose }) => {
  const token = localStorage.getItem('token');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('all');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 50;

  const load = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        filter: tab,
        page: page.toString(),
        pageSize: pageSize.toString()
      });
      if (search) params.append('search', search);
      const res = await apiFetch(`/api/email-marketing/campaigns/${campaignId}/contacts?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.ok) {
        setRows(Array.isArray(data?.items) ? data.items : []);
        setTotal(Number(data?.total || 0));
      }
    } catch (err) {
      console.error('Error cargando jobs', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId, tab, page, search]);

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Detalle de campaña</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <ul className="nav nav-tabs mb-3">
              <li className="nav-item">
                <button className={`nav-link ${tab === 'all' ? 'active' : ''}`} onClick={() => { setTab('all'); setPage(1); }}>
                  Envíos
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${tab === 'open' ? 'active' : ''}`} onClick={() => { setTab('open'); setPage(1); }}>
                  Aperturas
                </button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${tab === 'click' ? 'active' : ''}`} onClick={() => { setTab('click'); setPage(1); }}>
                  Clicks
                </button>
              </li>
            </ul>
            <div className="d-flex gap-2 align-items-end mb-3">
              <div className="flex-grow-1">
                <label className="form-label small">Buscar</label>
                <input
                  className="form-control form-control-sm"
                  placeholder="Email o nombre"
                  value={search}
                  onChange={(e) => { setPage(1); setSearch(e.target.value); }}
                />
              </div>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => { setSearch(''); setPage(1); }}>
                Limpiar
              </button>
            </div>
            {loading ? (
              <div className="text-muted">Cargando...</div>
            ) : rows.length ? (
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Nombre</th>
                      <th>Estado</th>
                      <th>Error</th>
                      <th>Enviado</th>
                      <th>Abierto</th>
                      <th>Click</th>
                      <th>Unsub</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((j) => (
                      <tr key={j.id}>
                        <td>{j.contact_email}</td>
                        <td>{j.contact_name || '-'}</td>
                        <td>{j.status}</td>
                        <td className="text-danger small">{j.error_text || ''}</td>
                        <td>{j.sent_at ? new Date(j.sent_at).toLocaleString() : '-'}</td>
                        <td>{j.opened_at ? new Date(j.opened_at).toLocaleString() : '-'}</td>
                        <td>{j.clicked_at ? new Date(j.clicked_at).toLocaleString() : '-'}</td>
                        <td>{j.unsubscribed_at ? new Date(j.unsubscribed_at).toLocaleString() : '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <div className="text-muted small">Total: {total}</div>
                  <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Anterior</button>
                    <span className="small">Página {page} / {totalPages}</span>
                    <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Siguiente</button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-muted small">Sin resultados.</div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailMarketingJobsModal;
